<template>

  <div>
    <b-sidebar
      id="add-new-user-sidebar"
      :visible="isEditEmailAddressSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @hidden="resetForm"
      @change="(val) => $emit('update:is-add-new-product-sidebar-active', val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            {{ $t('E Posta Adresi') }}
          </h5>

          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />

        </div>

        <!-- BODY -->
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(saveData)"
            @reset.prevent="resetForm"
          >

            <!-- Firma ad -->
            <validation-provider
              #default="validationContext"
              :name="$t('E-Posta Adresi')"
              rules="required|email"
            >
              <b-form-group
                :label="$t('E-Posta Adresi')"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="emailAddressData.email"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                {{ $t('Kaydet') }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                {{ $t('Vazgeç') }}
              </b-button>
            </div>

          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
    <!-- Filters -->

    <!-- Table Container Card -->
    <b-card
      :title="$t('E Posta Kara Liste')"
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>{{ $t('Show') }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ $t('Entries') }}</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-if="false"
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="addData"
              >
                <span class="text-nowrap">{{ $t('Kara Listeye Yeni Mail Ekle') }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>
      <b-alert
        variant="warning"
        show
      >
        <div class="alert-body">
          <span>{{ $t('E posta kara listesi sadece toplu mailler için geçerlidir. Teklif maili v.b işlem maillerinde kara liste geçersizdir.') }}</span>
        </div>
      </b-alert>
      <b-table
        ref="refEmailAddressListTable"
        class="position-relative"
        :items="fetchEmailCategories"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="editData(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Düzenle') }} </span>
            </b-dropdown-item>
            <b-dropdown-item
              variant="danger"
              @click="deleteData(data.item)"
            >
              <feather-icon icon="Trash2Icon" />
              <span class="align-middle ml-50">{{ $t('Sil') }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t('Gösterilen') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} {{ $t('Entries') }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalEmailAddress"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BDropdown, BDropdownItem, BPagination, BSidebar, BFormGroup, BFormInvalidFeedback, BForm, BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import useEmailAddressList from './useEmailAddressList'
import emailStoreModule from '../emailStoreModule'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAlert,
    BSidebar,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
    }
  },
  methods: {
    deleteData(item) {
      this.$swal({
        title: this.$t('Emin Misiniz ?'),
        text: this.$t('Bu E-posta adresi kara listeden silinecek'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Silme İşlemini Onayla'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('app-email/deleteEmailBlacklist', { id: item.id })
            .then(() => {
              this.$refs.refEmailAddressListTable.refresh()
              this.showSuccessMessage()
            })
            .catch(() => {
              this.showErrorMessage()
            })
        }
      })
    },
    showSuccessMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarılı'), {
        title: this.$t('İşlem Başarılı'),
        variant: 'success',
        solid: false,
      })
    },
    showErrorMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarısız'), {
        title: this.$t('İşlem Başarısız'),
        variant: 'danger',
        solid: false,
      })
    },
    saveData() {
      if (this.emailAddressData.id === 0) {
        store.dispatch('app-email/addEmailBlacklist', this.emailAddressData)
          .then(() => {
            this.$refs.refEmailAddressListTable.refresh()
            this.isEditEmailAddressSidebarActive = false
            this.showSuccessMessage()
          })
      } else {
        store.dispatch('app-email/updateEmailBlacklist', this.emailAddressData)
          .then(() => {
            this.$refs.refEmailAddressListTable.refresh()
            this.isEditEmailAddressSidebarActive = false
            this.showSuccessMessage()
          })
      }
    },
    editData(item) {
      this.emailAddressData = JSON.parse(JSON.stringify(item))
      this.isEditEmailAddressSidebarActive = true
    },
    addData() {
      this.resetEmailAddressData()
      this.isEditEmailAddressSidebarActive = true
    },
    addIsSuccess(id) {
      this.editEmailAddressId = id
      this.isEditEmailAddressSidebarActive = true
    },
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'app-email'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, emailStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })
    const editEmailAddressId = ref(0)
    const isAddNewEmailAddressSidebarActive = ref(false)
    const isEditEmailAddressSidebarActive = ref(false)
    const emailAddressData = ref(null)
    const blankEmailAddressData = {
      id: 0,
      email: '',
    }
    const {
      fetchEmailCategories,
      tableColumns,
      perPage,
      currentPage,
      totalEmailAddress,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refEmailAddressListTable,
      refetchData,
      // UI

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useEmailAddressList()
    const resetEmailAddressData = () => {
      emailAddressData.value = JSON.parse(JSON.stringify(blankEmailAddressData))
    }
    resetEmailAddressData()
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetEmailAddressData)
    return {

      // Sidebar
      isAddNewEmailAddressSidebarActive,
      isEditEmailAddressSidebarActive,
      fetchEmailCategories,
      tableColumns,
      perPage,
      currentPage,
      totalEmailAddress,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      refFormObserver,
      emailAddressData,
      resetEmailAddressData,
      getValidationState,
      resetForm,
      editEmailAddressId,
      isSortDirDesc,
      refEmailAddressListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      blankEmailAddressData,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
